import React, { useEffect, useState } from 'react'
import { scrimRules } from '../../../api/scrim.api';
import ListLoader from '../../Common/ListLoader';

const ManageRules = ({ scrimId }) => {
  const [rules, setRules] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true)
    fetchRules();
  }, [scrimId])

  const fetchRules = async () => {
    try {
      var response = await scrimRules(scrimId);
      if (response?.success && response?.rules) {
        setRules(response?.rules)
      }
      setLoading(false)
    } catch (error) { setLoading(false) }
  };

  return (
    <div className="private-scrim-game-rules private-scrims-manage-rules private-scrims-manage-rules-height-update">

      <div className="rules-list private-contest-manage-height " dangerouslySetInnerHTML={{ __html: rules }} />
      {loading && <div className={'w-100 d-flex justify-content-center no-record-found-center'}> <ListLoader /></div>}
    </div>
  )
}

export default ManageRules